<script>
import { mapActions } from "vuex";
import TargetsTab from "../KPIsMetrics/targets.vue";
import Documents from './kpiDocs.vue';
import SwitchButton from "../../components/SwitchButton.vue";
import MixedIcons from "../../assets/icons/MixedIcons.vue";
import i18n from "@/plugins/i18n";
import { quarters as defaultQuarters } from "../../utils/config";
import StatusComponent from "./components/StatusComponent.vue";

const CarbonLogo = "/images/SustAppLogos/Sustainfinity-Carbon-Logo.png";

export default {
    components: {
        TargetsTab,
        Documents,
        SwitchButton,
        MixedIcons,

        StatusComponent,
    },

    data() {
        return {
            auditedCompanyId: null,
            activeTab: "metrics",

            values: [],
            documentsWithMetrics: {},

            updateModal: false,
            selectedInputID: "",
            selectedInputType: "",

            loading: false,
            facilities: [],
            selectedFacility: null,
            selectedFacilityID: null,
            selectedCategoryID: null,

            documentsModal: false,
            kpiType: "",
            kpiID: "",
            kpiYear: null,
            kpiQuarter: null,

            isYearly: true,

            years: [2024, 2023, 2022, 2021, 2020, 2019],
            quarters: [],

            maxYear: 2024,

            selectedYear: 2024,

            apps: [
                { val: "carbon", type: "app", logo: CarbonLogo, text: "Carbon Module", icon: null }
            ],

            metricStatusButtons: [
                {
                    is_active: false,
                    key: 'approved',
                    text: i18n.t('auditor.status.approved'),
                    callback: (metric, is_document = false, is_metric = true) => () => {
                        if (!is_document) {
                            this._changeMetricStatus(metric.values.find(value => value.year == this.selectedYear), 'approved');
                        } else {
                            this._changeDocumentStatus(
                                is_metric ?
                                    this.hasMetricDocument(metric.metric_kpi_id, metric.values.find(value => value.year == this.selectedYear).year, 5)
                                : 
                                    this.hasSubmetricDocument(metric.sub_metric_kpi_id, metric.values.find(value => value.quarter == 5).year, 5),
                                    'approved'
                            )
                        }
                    },
                    color: 'var(--sustainfinity-green) !important',
                },
                {
                    is_active: false,
                    key: 'recheck',
                    text: i18n.t('auditor.status.recheck'),
                    callback: (metric, is_document = false, is_metric = true) => () => {
                        if (!is_document) {
                            this._changeMetricStatus(metric.values.find(value => value.year == this.selectedYear), 'recheck');
                        } else {
                            this._changeDocumentStatus(
                                is_metric ?
                                    this.hasMetricDocument(metric.metric_kpi_id, metric.values.find(value => value.year == this.selectedYear).year, 5)
                                : 
                                    this.hasSubmetricDocument(metric.sub_metric_kpi_id, metric.values.find(value => value.quarter == 5).year, 5),
                                    'recheck'
                            )
                        }
                    },
                    color: 'var(--sustainfinity-blue) !important',
                },
                {
                    is_active: false,
                    key: 'disapproved',
                    text: i18n.t('auditor.status.disapproved'),
                    callback: (metric, is_document = false, is_metric = true) => () => {
                        if (!is_document) {
                            this._changeMetricStatus(metric.values.find(value => value.year == this.selectedYear), 'disapproved');
                        } else {
                            this._changeDocumentStatus(
                                is_metric ?
                                    this.hasMetricDocument(metric.metric_kpi_id, metric.values.find(value => value.year == this.selectedYear).year, 5)
                                : 
                                    this.hasSubmetricDocument(metric.sub_metric_kpi_id, metric.values.find(value => value.quarter == 5).year, 5),
                                    'disapproved'
                            )
                        }
                    },
                    color: 'var(--invalid-input) !important',
                },
            ],
        }
    },

    computed: {
        selectedYears() {
            return [this.maxYear - 2, this.maxYear - 1, this.maxYear];
        },

        switchButtonLabels() {
            const yearly = i18n.t("kpisMetrics.yearly_metrics");
            const quarterly = i18n.t("kpisMetrics.quarterly_metrics");
            return [yearly, quarterly];
        },

        hasSingleFacility() {
            // !! facility length amounts to 2 because we push an additional company based facility!!!
            return (this.facilities.length == 2); 
        },
    },

    mounted() {
        const proceed = this.setupAuditedCompany();
        if (proceed) {
            this.setInitialMaxYear();
            this._getDocumentsWithMetrics();
            this.companyInfo();
            this.myFacilities();
        }
    },

    methods: {
        setupAuditedCompany() {
            const id = sessionStorage.getItem('audited_company_id');
            if (id) {
                this.auditedCompanyId = Number(id);
                return true
            } else {
                this.$notify('error', 'You must select a company to audit.', true);
                return false;
            }
        },

        ...mapActions('auditor', [
            'getMetricsMonitoringByCompanyId',
            'getTotalMetricsMonitoringByCompanyId',
            'addMetricInputComment',
            'changeMetricStatus',
            'changeDocumentStatus',

        ]),

        _addMetricInputComment(input) {
            const backup = input.auditor_comments;

            const params = {
                total_metric_input_id: input.id,
                comment: input.auditor_comments,
            }

            this.addMetricInputComment(params)
                .then(res => {
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    input.auditor_comments = backup;
                    this.$notify('error', response.data.messageName);
                })
        },

        _changeMetricStatus(input, status) {
            const backup = input.metric_audit_status;

            const params = {
                total_metric_input_id: input.id,
                status: status
            }

            this.changeMetricStatus(params)
                .then(res => {
                    input.metric_audit_status = params.status;
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    input.metric_audit_status = backup;
                    this.$notify('error', response.data.messageName);
                })
        },
        
        _changeDocumentStatus(document, status) {
            if (!document) {
                this.$notify('error', 'There is no uploaded document to audit for the given metric.', true); //TODO: language
                return;
            }

            const backup = document.document_audit_status;

            const params = {
                document_id: document.document_id,
                status: status
            }

            this.changeDocumentStatus(params)
                .then(res => {
                    document.document_audit_status = params.status;
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    document.document_audit_status = backup;
                    this.$notify('error', response.data.messageName);
                })
        },

        ...mapActions("KPIsMetrics", [
            "createMetricsInput",
            "getCompaines",
            "getFacilities",
            "updateMetrics"
        ]),
        ...mapActions("company", ["getCompanyInfo"]),
        ...mapActions("additionalsettings", ["getCategory"]),
        ...mapActions("documentation", ["getDocumentsWithMetrics"]),

        async _getMetricsMonitoringByCompanyId() {
            try {
                await this.setLoading(true);
                await this.resetValues();

                let params = {
                    is_deleted: false,
                    company_id: this.auditedCompanyId,
                    facility_id: this.selectedFacilityID,
                    min_year: this.selectedYear,
                    max_year: this.selectedYear,
                };

                if (params.facility_id != 0) {
                    await this.getMetricsMonitoringByCompanyId(params)
                        .then(res => {
                            for (const category in res.data) {
                                if (Object.hasOwnProperty.call(res.data, category)) {
                                    const category_value = res.data[category];

                                    this.values.push(category_value);
                                }
                            }
                        })
                        .catch(({ response }) => {
                            console.error(response.message);
                        })
                        .finally(() => {
                            this.setLoading(false);
                        })
                } else {
                    delete params.facility_id;
                    this.getTotalMetricsMonitoringByCompanyId(params)
                        .then(res => {
                            for (const category in res.data) {
                                if (Object.hasOwnProperty.call(res.data, category)) {
                                    const category_value = res.data[category];

                                    this.values.push(category_value);
                                }
                            }
                        })
                        .catch(({ response }) => {
                            console.error(response.message);
                        })
                        .finally(() => {
                            this.setLoading(false);
                        })
                }
            } catch (error) {
                throw new Error(error.message);
            }
        },

        companyInfo() {
            let params = {
                company_id: this.auditedCompanyId,
            };
            this.getCompanyInfo(params)
                .then((res) => {
                    this.sectorID = res.data[0].sector_id;
                })
                .catch(({ response }) => {
                    this.$toast.open({
                        message: this.$parseResMessage(response.data.messageName),
                        type: "error",
                        duration: 5000,
                        dismissible: true,
                    });
                })
        },

        myFacilities() {
            const params = {
                company_id: this.auditedCompanyId,
                is_deleted: false
            };
            this.getFacilities(params)
                .then(res => {
                    this.facilities = res.data;
                    this.facilities.push(
                        {
                            facility_name: i18n.t('kpisMetrics.company_based'),
                            facility_id: 0
                        }
                    )
                })
                .finally(() => {
                    const length = this.facilities.length;
                    this.selectedFacility = this.facilities[length - 1].facility_name;
                    if (this.facilities.length == 2) { // !! facility length amounts to 2 because we push an additional company based facility!!!
                        this.selectedFacilityID = this.facilities[0].facility_id;
                    } else if (this.facilities.length > 1) {
                        this.selectedFacilityID = this.facilities[length - 1].facility_id;
                    }
                    this._getMetricsMonitoringByCompanyId()
                })
        },

        clickItem(item) {
            try {
                if (item.val === "sust") {
                    this.$router.push("/dashboard");
                } else if (item.val === "carbon") {
                    window.open(process.env.VUE_APP_CARBON_DOMAIN);
                }
            } catch (error) {
                console.error(error.message);
            } finally {
                this.CloseApps();
            }
        },

        async onFacilityChange() {
            this.activeTab = "metrics",
                await this._getMetricsMonitoringByCompanyId();
        },

        goToKPIPage(name, type) { // for future use //
            this.$router.push({ path: "/kpi-metrics", query: { q: name, type: type } });
        },

        setInitialMaxYear() {
            this.quarters = defaultQuarters;
            const year = new Date().getFullYear();
            this.selectedYear = year - 1;
            this.years = [year, year - 1, year - 2, year - 3, year - 4, year - 5];
            this.maxYear = new Date().getFullYear() - 1;
            this.selectedYears = [this.maxYear - 2, this.maxYear - 1, this.maxYear];
        },

        // setters //

        async setMaxYear(year) {
            this.maxYear = year;
        },

        async setYear(year) {
            this.selectedYear = year;
        },

        async setLoading(bool) {
            this.loading = bool;
        },

        async resetValues() {
            this.values = [];
        },

        async setButtonState(state) {
            this.isYearly = state;
        },

        // utils //

        async checkButtonState(state) {
            await this.setButtonState(state);
            await this._getMetricsMonitoringByCompanyId();
        },

        async changeMaxYear(direction) {
            try {
                const yearsRange = this.years.length;
                if (direction == "left" && (this.maxYear - 2 != this.years[yearsRange - 1])) {
                    const newMaxYear = this.maxYear - 1;
                    await this.setMaxYear(newMaxYear);
                    await this._getMetricsMonitoringByCompanyId();
                } else if (direction == "right" && this.maxYear != this.years[0]) {
                    const newMaxYear = this.maxYear + 1;
                    await this.setMaxYear(newMaxYear);
                    await this._getMetricsMonitoringByCompanyId();
                } else if (direction != "right" && direction != "left") {
                    throw new Error("Invalid direction on changeMaxYear!");
                }
            } catch (error) {
                console.error(error.message);
                throw new Error(error);
            }
        },

        async changeSelectedYear(direction) {
            try {
                const yearsRange = this.years.length;
                if (direction == "left" && (this.selectedYear != this.years[yearsRange - 1])) {
                    const newMaxYear = this.selectedYear - 1;
                    await this.setYear(newMaxYear);
                    await this._getMetricsMonitoringByCompanyId();
                } else if (direction == "right" && this.selectedYear != this.years[0]) {
                    const newMaxYear = this.selectedYear + 1;
                    await this.setYear(newMaxYear);
                    await this._getMetricsMonitoringByCompanyId();
                } else if (direction != "right" && direction != "left") {
                    throw new Error("Invalid direction on changeSelectedYear!");
                }
            } catch (error) {
                console.error(error.message);
                throw new Error(error);
            }
        },

        changeTab(tab) {
            this.activeTab = tab;
        },

        goToKpi(category, element, metric) {
            this.$router.push({ path: '/kpi-metrics', query: { category: category.name, element: element.sust_element_name, metric: metric.sust_metric_kpi_name } })
        },

        openDocumentsModal(item, year, quarter) {
            this.kpiYear = year;
            this.kpiQuarter = quarter;
            if (item.sub_metric_kpi_id) {
                this.kpiType = "submetric";
                this.kpiID = item.sub_metric_kpi_id;
            } else {
                this.kpiType = "metric";
                this.kpiID = item.metric_kpi_id;
            }

            if (!item)
                throw new Error("Undefined parameter at openDocumentsModal! \n", item);

            this.documentsModal = true;
        },

        scrollToView(ref) {
            if (ref == "category_1") {
                this.selectedCategoryID = 1;
            }
            if (ref == "category_2") {
                this.selectedCategoryID = 2;
            }
            if (ref == "category_3") {
                this.selectedCategoryID = 3;
            }
            if (ref == "category_4") {
                this.selectedCategoryID = 4;
            }

            const target = document.getElementById(ref);
            if (target) {
                target.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "end"
                })
            }
        },

        onEmptyValue(value) {
            if (!value) {
                return "-";
            } else {
                return value;
            }
        },

        getColor(id) {
            if (id == 1) {
                return '#fa8a14'
            }
            if (id == 2) {
                return '#44a900'
            }
            if (id == 3) {
                return '#de0222'
            }
            if (id == 4) {
                return '#004578'
            }
        },

        _getDocumentsWithMetrics() {
            const params = {
                company_id: this.auditedCompanyId,
                is_deleted: false
            }

            this.getDocumentsWithMetrics(params)
                .then(res => {
                    this.documentsWithMetrics = res.data;
                })
                .catch(({ response }) => {
                    console.error(this.$parseResMessage(response.message));
                })
        },

        hasMetricDocument(metric_kpi_id, year, quarter) {
            if (!this.documentsWithMetrics.hasOwnProperty("metric_kpis")) {
                return false;
            }

            let has = false;
            const metric_documents = this.documentsWithMetrics.metric_kpis;
            for (let index = 0; index < metric_documents.length; index++) {
                const document = metric_documents[index];

                if (document.metric_kpi_ids.some(id => id == metric_kpi_id) && document.quarter == quarter && document.year == year) {
                    has = document;
                    break;
                }
            }
            return has;
        },

        hasSubmetricDocument(sub_metric_kpi_id, year, quarter) {
            if (!this.documentsWithMetrics.hasOwnProperty("sub_metric_kpis")) {
                return false;
            }

            let has = false;
            const sub_metric_documents = this.documentsWithMetrics.sub_metric_kpis;
            for (let index = 0; index < sub_metric_documents.length; index++) {
                const document = sub_metric_documents[index];

                if (document.sub_metric_kpi_ids.some(id => id == sub_metric_kpi_id) && document.quarter == quarter && document.year == year) {
                    has = document;
                    break;
                }
            }
            return has;
        },

        getAuditButtonColor(values, status) {
            if (values) {
                const value = values.find(v => v.year == this.selectedYear);
                if (value) {
                    return value.metric_audit_status === status;
                }

                return false;
            }

            return false;
        },
    },
}
</script>

<template>
    <div class="flex-all-centered-row" style="align-items: flex-start;">
        <div class="categories-container flex-all-centered-col" style="justify-content: flex-start;">
            <loading-spinner v-if="loading" :container="true" />
            
            <div class="flex-all-centered-col" style="justify-content: flex-start;">
                <div class="top-select-inputs">
                    <select v-if="activeTab === 'metrics' && !hasSingleFacility" class="monitor-page-facility-select"
                        style="max-height: 35px; align-self: flex-start;" v-model="selectedFacilityID"
                        @change="onFacilityChange">
                        <option v-for="(facility, index) in facilities" :key="index" :value="facility.facility_id">
                            {{ facility.facility_name }}
                        </option>
                    </select>

                    <div class="year-selector">
                        <i class="fa-solid fa-caret-left pr-2" @click="changeSelectedYear('left')"></i>
                        {{ selectedYear }}
                        <i class="fa-solid fa-caret-right pl-2" @click="changeSelectedYear('right')"></i>
                    </div>
                </div>
            </div>

            <div class="flex-all-centered-col" v-if="activeTab === 'metrics' && isYearly">
                <div class="category-section" v-for="(category, index) in values" :key="index">
                    <div class="category-name" :style="{ 'borderBottomColor': getColor(category.id) }"
                        :id="category.ref" v-if="category.elements.length > 0">
                        <div class="category-name--border" :style="{ 'borderBottomColor': getColor(category.id) }">
                            {{ category.name }}
                        </div>
                    </div>
                    <div class="category-card" v-for="(element, elementIndex) in category.elements" :key="elementIndex">
                        <div class="element-name" :style="{ 'color': getColor(category.id) }">
                            {{ element.sust_element_name }}
                        </div>

                        <div class="row headers justify-content-start">
                            <div class="metric-name--header" :style="{ 'backgroundColor': getColor(category.id) }">
                                {{ $t('kpisMetrics.metrics').toUpperCase() }}
                            </div>
                            <div class="years--header is-quarterly-cell"
                                :style="{ 'backgroundColor': getColor(category.id) }"
                            >
                                {{ selectedYear }}
                            </div>
                            <div class="years--header is-quarterly-cell"
                                :style="{ 'backgroundColor': getColor(category.id) }"
                            >
                                {{ $t('auditor.metrics.document') }}
                            </div>
                            <div class="is-audited--header"
                                :style="{ 'backgroundColor': getColor(category.id) }"
                            >
                                {{ $t('auditor.metrics.metric_status') }}
                            </div>
                            <div class="is-audited--header"
                                :style="{ 'backgroundColor': getColor(category.id) }"
                            >
                                {{ $t('auditor.metrics.document_status') }}
                            </div>
                        </div>

                        <div v-for="(metric, metricIndex) in element.metrics" :key="metricIndex">
                            <div class="row values">
                                <div :style="{ 'borderBottom': '.13em solid' + getColor(category.id) }"
                                    class="metric-name--value">
                                    <span @click="goToKpi(category, element, metric)">{{ metric.sust_metric_kpi_name }}
                                        ( {{ metric.unit_type }} )</span>
                                </div>
                                <div
                                    :style="{ 'borderBottom': '.13em solid' + getColor(category.id) }"
                                    class="years--value is-quarterly-cell"
                                >
                                    {{ metric.values.find(value => value.year == selectedYear) ? metric.values.find(value => value.year == selectedYear).value : "-" }}
                                </div>
                                <div
                                    :style="{ 'borderBottom': '.13em solid' + getColor(category.id) }"
                                    class="years--value is-quarterly-cell"
                                >
                                    <mixed-icons
                                        v-if="metric.submetrics.length == 0 && metric.values.find(value => value.year == selectedYear)"
                                        :hover="true" :name="'fa-regular fa-folder-open'"
                                        :main_color="getColor(category.id)"
                                        :side_class="hasMetricDocument(metric.metric_kpi_id, metric.values.find(value => value.year == selectedYear).year, 5) ? 'fa-solid fa-check' : null"
                                        :side_color="'var(--sustainfinity-green)'"
                                        @click="openDocumentsModal(metric, metric.values.find(value => value.year == selectedYear).year, 5)"
                                        class="documentation-icon" 
                                    />
                                </div>
                                <div class="status-component-wrapper" v-if="metric.values.length > 0"
                                    :style="{ 'borderBottom': '.13em solid' + getColor(category.id) }"
                                >
                                    <StatusComponent :buttons="metricStatusButtons.map(btn => ({
                                        ...btn,
                                        is_active: getAuditButtonColor(metric.values, btn.key),
                                        callback: btn.callback(metric)
                                    }))" />
                                </div>
                                <div class="status-wrapper" :style="{ 'borderBottom': '.13em solid' + getColor(category.id) }" v-else >-</div>
                                <div class="status-wrapper" v-if="metric.values.length > 0"
                                    :style="{ 'borderBottom': '.13em solid' + getColor(category.id) }"
                                >
                                    <StatusComponent :buttons="metricStatusButtons.map(btn => ({
                                        ...btn,
                                        is_active: hasMetricDocument(metric.metric_kpi_id, metric.values.find(value => value.year == selectedYear).year, 5).document_audit_status == btn.key,
                                        callback: btn.callback(metric, true, true)
                                    }))" />
                                </div>
                                <div class="status-wrapper" :style="{ 'borderBottom': '.13em solid' + getColor(category.id) }" v-else >-</div>
                                <div class="comments-wrapper" v-if="metric.values.length > 0"
                                    :style="{ 'borderBottom': '.13em solid' + getColor(category.id) }"
                                >   
                                    {{ $t('auditor.status.comments') }}
                                    <textarea rows="2"
                                        v-model="metric.values[0].auditor_comments" 
                                        @change="_addMetricInputComment(metric.values[0])"
                                    >
                                    </textarea>
                                </div>
                            </div>

                            <div class="row sub-values" v-for="(submetric, submetricIndex) in metric.submetrics"
                                :key="submetricIndex">
                                <div :style="{ 'borderBottom': '.15em dashed' + getColor(category.id) }"
                                    class="sub-metric-name--value">
                                    {{ submetric.sust_sub_metric_kpi_name }} ( {{ metric.unit_type }} )
                                </div>
                                <div
                                    :style="{ 'borderBottom': '.15em dashed' + getColor(category.id) }"
                                    class="sub-years--value is-quarterly-cell"
                                >
                                    {{ submetric.values.find(value => value.quarter == 5) ? submetric.values.find(value => value.quarter == 5).value : "-" }}
                                </div>
                                <div
                                    :style="{ 'borderBottom': '.15em dashed' + getColor(category.id) }"
                                    class="sub-years--value is-quarterly-cell"
                                >
                                <mixed-icons
                                        v-if="submetric.values.find(value => value.year === selectedYear)"
                                        :hover="true" :name="'fa-regular fa-folder-open'"
                                        :main_color="getColor(category.id)"
                                        :side_class="hasSubmetricDocument(submetric.sub_metric_kpi_id, submetric.values.find(value => value.quarter == 5).year, 5) ? 'fa-solid fa-check' : null"
                                        :side_color="'var(--sustainfinity-green)'"
                                        @click="openDocumentsModal(submetric, submetric.values.find(value => value.quarter == 5).year, 5)"
                                        class="documentation-icon" 
                                    />
                                </div>
                                <div class="status-wrapper"
                                    :style="{ 'borderBottom': '.13em solid' + getColor(category.id) }"
                                >
                                    <StatusComponent :buttons="metricStatusButtons.map(btn => ({
                                        ...btn,
                                        is_active: getAuditButtonColor(submetric.values, btn.key),
                                        callback: btn.callback(submetric)
                                    }))" />
                                </div>
                                <div class="status-wrapper"
                                    :style="{ 'borderBottom': '.13em solid' + getColor(category.id) }"
                                >
                                    <StatusComponent :buttons="metricStatusButtons.map(btn => ({
                                        ...btn,
                                        is_active: hasSubmetricDocument(submetric.sub_metric_kpi_id, submetric.values.find(value => value.quarter == 5).year, 5).document_audit_status == btn.key,
                                        callback: btn.callback(submetric, true, false)
                                    }))" />
                                </div>
                                <div class="comments-wrapper" v-if="submetric.values.length > 0"
                                    :style="{ 'borderBottom': '.13em solid' + getColor(category.id) }"
                                >   
                                    {{ $t('auditor.status.comments') }}
                                    <textarea rows="2"
                                        v-model="submetric.values[0].auditor_comments" 
                                        @change="_addMetricInputComment(submetric.values[0])"
                                    >
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!values || values.length == 0 || values == undefined">
                <br><br><br>
                <h5>{{ $t('kpisMetrics.no_values') }}</h5>
            </div>

            <targets-tab v-if="activeTab === 'targets'" />
        </div>

        <b-modal hide-header hide-footer centered size="xl" v-model="documentsModal">
            <div style="
              width: 100%; 
              min-height: fit-content;
            ">
                <Documents 
                    :kpiType="kpiType"
                    :kpiID="kpiID"
                    :year="kpiYear"
                    :quarter="kpiQuarter"
                    :readOnly="true"
                    :companyID="auditedCompanyId"
                />
            </div>
        </b-modal>
    </div>
</template>

<style scoped lang="scss">
.category-elements--container {
    top: 7.25em;
}


.category-section {
    width: 100%;
    margin-bottom: 2em;
}

.category-card {
    position: relative;
}

.category-name {
    font-size: 1.66rem;
    font-weight: bold;
    color: #023047;

    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.category-name--border {
    border-bottom: medium solid;
    max-width: fit-content;
    margin-right: 2.5%;
}

.category-card {
    filter: drop-shadow(0 .25em .33em gray) !important;
    border: thin solid lightgray;
    border-radius: 1em;

    margin-top: 1em;
    margin-right: 2em;

    background-color: #f5f5f5;

    padding: 1em;
}

.element-name {
    font-weight: bold;
    font-size: 1rem;

    padding-bottom: 1em;
    padding-left: .5em;
}

.headers {
    margin-left: .33em;

    font-size: .9rem;
}

.headers>div {
    border-top-left-radius: 1em;
    border-top-right-radius: 1em;

    margin-right: .33em;
    padding: .5em;

    color: white;
    font-weight: bolder;

    filter: drop-shadow(0 0 .33em lightgray);
}

.metric-name--header {
    width: 30%;
}

.years--header {
    width: 18%;
    text-align: center;
}

.comments--header {
    width: 46% !important;
    text-align: center;
}

.is-audited--header {
    width: 26% !important;
    text-align: center;
}

.values {
    margin-left: .33em;

    font-size: .8rem;
}

.values>div {
    margin-right: .33em;
    padding: .5em;

    color: #023047;
    font-weight: bold;

    background-color: #f3f3f3;

    filter: drop-shadow(0 0 .33em lightgray);
}

.metric-name--value {
    width: 30%;

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;
    align-items: center;

    >span {
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }
}

.years--value {
    position: relative;
    width: 18%;
    text-align: center;
}

.sub-values {
    margin-left: .33em;
    font-size: .8rem;

    text-align: center;
}

.sub-values>div {
    margin-right: .33em;
    padding: .5em;

    color: #023047;
    font-weight: bold;

    background-color: #f3f3f3;

    border-bottom: thin dashed lightgray;

    filter: drop-shadow(0 0 .33em lightgray);
}

.sub-metric-name--value {
    width: 30%;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;

    position: relative;

    >.go-to-kpi {
        position: absolute;
        left: .3em;
    }
}

.sub-years--value {
    width: 18%;

    text-align: center;
}

.tabs-bar {
    margin-top: 1em;

    &>.tab {
        background-color: var(--sustainfinity-navy);
        color: white;
        font-weight: bold;
        padding: .33em;
        cursor: pointer;

    }

    &>.report-sections-bar {
        border: .2em solid var(--sustainfinity-navy);
        border-top-left-radius: 1em;
        border-bottom-left-radius: 1em;
    }

    &>.section-texts-bar {
        border: .2em solid var(--sustainfinity-navy);
        border-top-right-radius: 1em;
        border-bottom-right-radius: 1em;
    }

    &>.active-tab {
        background-color: white !important;
        color: var(--sustainfinity-navy) !important;
    }
}

.go-to-kpi {
    font-size: 1.5em;
    padding: 0 1em 0 1em;

    transition: all 100ms;
    cursor: pointer;

    &:hover {
        filter: brightness(120%);
    }
}

.top-select-inputs {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    width: 100%;
    transform: translateY(2em);

    >.monitor-page-facility-select {
        border: 0;
        border-bottom: thin solid var(--sustainfinity-navy);
        outline: 0;
        background: 0;
        padding: .33em .66em .33em .66em;

        cursor: pointer;

        &:focus {
            outline: thin solid var(--sustainfinity-navy);
        }
    }

    >.year-selector {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
        align-items: center;
        margin-left: 3em;

        >i {
            transform: translateY(5%);
            cursor: pointer;
            transition: all 100ms;

            &:hover {
                color: darkgray;
            }
        }
    }
}

.documentation-icon {
    justify-self: center;
    align-self: center;
    font-size: 12px;
    color: whitesmoke;
    scale: .6;

    transition: 100ms;
    cursor: pointer;

    &:hover {
        filter: brightness(50%);
    }
}

.switch-button {
    margin-left: 3em;
}

.is-quarterly-cell {
    width: 7% !important;
}

.comments-wrapper {
    width: 97% !important;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    > textarea {
        width: 98%;
        border: 0;
        outline: thin solid lightgray;
        border-radius: .25em;
        padding: .1em;

        &:focus {
            outline: thin solid gray !important;
        }
    }
}

.status-component-wrapper {
    width: 26%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.status-wrapper {
    width: 26%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    button {
        border: 0;
        outline: 0;
        color: white;
        min-width: 20%;
        padding: .25em;
        background-color: rgb(142, 142, 142);
        transition: background-color 150ms;
        
        &:first-of-type {
            border-top-left-radius: .3em;
            border-bottom-left-radius: .3em;
            border-right: thin solid lightgray;

            &:hover {
                background-color: var(--sustainfinity-green);
            }
        }

        &:nth-of-type(2) {

            &:hover {
                background-color: var(--sustainfinity-blue);
            }
        }
        
        &:nth-of-type(3) {
            border-top-right-radius: .3em;
            border-bottom-right-radius: .3em;
            border-left: thin solid lightgray;

            &:hover {
                background-color: var(--invalid-input);
            }
        }
    }
}

</style>